<template>
    <div class="purchase-outfit-container page-container">
        <purchase-outfit
            v-if="!dataLoading"
            :outfitCurrent="currentOutfit"
            :returnTitle="returnTitle"
            :returnPath="returnPath">
        </purchase-outfit>
        <transition name="fade">
            <div v-show="dataLoading" class="loading-overlay">
                <loader></loader>
            </div>
        </transition>
    </div>
</template>

<script>
    import PurchaseOutfit from './purchase-outfit.vue';
    import Loader from '../common/loader.vue';
    import {mapGetters} from 'vuex';
    import { OUTFIT_TYPES } from '../../config.js';

    export default {
        data(){
            return {
                returnTitle: null,
                returnPath: null,
                dataLoading: true,
            };
        },
        components:{
            PurchaseOutfit,
            Loader,
        },
        computed:{
            ...mapGetters({
                'currentOutfit': 'outfits/currentOutfit',
            })
        },
        created(){
            const { outfitType, outfitId } = this.$route.query;

            if(outfitType == OUTFIT_TYPES.SAVED){
                this.returnTitle = 'Back to Saved Outfit';
                this.returnPath = '/saved-outfits';
            } else if (outfitType == OUTFIT_TYPES.FEATURED) {
                this.returnTitle = 'Back to Featured Outfits';
                this.returnPath = '/shop';
            } else if (outfitType == OUTFIT_TYPES.GENERATED) {
                this.returnTitle = "Back to Outfit";
                this.returnPath = '/get-styled';
            } else if (outfitType == OUTFIT_TYPES.CART) {
                this.returnTitle = "Back to Cart";
                this.returnPath = '/cart';
            }

            //Fetch outfit
            if(outfitId && (!this.currentOutfit || this.currentOutfit.outfit_id !== outfitId || !this.currentOutfit.isDetailed)) {
                this.$store.dispatch('outfits/fetchOutfit', {
                    outfitId,
                    outfitType,
                }).finally(() => this.dataLoading = false);
            } else {
                this.dataLoading = false;
            }
        }
    }

</script>